export default {
  portal: {
    title: "Supplier Portal",
    welcomeMessage: "Beheer uw boekingen en bekijk toekomstige schema's",
    noBookings: "Geen boekingen gevonden",
    noBookingsSub: "Er zijn geen boekingen om weer te geven voor de geselecteerde periode.",
    caseNumber: "Dossier #",
    client: "Klant",
    firstName: "Voornaam",
    lastName: "Achternaam",
    clientPhone: "Telefoon",
    clientEmail: "E-mail",
    clientAddress: "Adres van de Klant",
    clientObservations: "Klantopmerkingen",
    clientDetails: "Klant Details",
    checkIn: "Inchecken",
    checkOut: "Uitchecken",
    nights: "nachten",
    supplierName: "Leverancier",
    location: "Locatie",
    roomType: "Kamertype",
    dates: "Data",
    resource: "Product",
    details: "Details",
    price: "Prijs",
    total: "Totaal",
    status: "Status",
    bookingStatus: "Boeking",
    paymentStatus: "Betaling",
    invoiceStatus: "Factura",
    quantity: "Aant",
    pax: "Pax",
    upcoming: "Aankomend",
    past: "Verleden",
    searchLabel: "Klant / Dossiernaam / Dossier #",
    searchPlaceholder: "Zoeken op klant, dossiernaam of dossier #...",
    clearFilters: "Filters wissen",
    clientTooltip: "Klantgegevens zijn zichtbaar 48 uur voor inchecken",
    priceTooltip: "Klik op het potloodicoon om uw prijs in te voeren",
    editPriceTooltip: "Bewerk uw prijs",
    caseNumberTooltip: "Intern boekingsreferentienummer"
  },
  sendPortalLink: "Stuur portaal login link",
  sendPortalLinkConfirmTitle: "Stuur portaal link",
  sendPortalLinkConfirmText: "Weet u zeker dat u de portaal login link wilt sturen naar \"{supplier}\"?",
  sendPortalLinkSuccess: "E-mail succesvol verzonden",
  sendPortalLinkError: "Kon de e-mail niet verzenden",
  portalLoginLinkSection: "Toegang tot leveranciersportaal",
  portalLoginLinkDescription: "Stuur een e-mail naar de leverancier met de inloglink voor ons leveranciersportaal.",
  suppliers: "Leveranciers",
  noSuppliers: "Er zijn geen leveranciers",
  createNewSupplier: "Nieuwe leverancier aanmaken",
  archivedSuppliers: "Gearchiveerde leveranciers",
  activeSuppliers: "Actieve leveranciers",
  basicInformation: "Basisinformatie",
  supplierDetails: "Leveranciersdetails",
  email: "E-mail voor meldingen",
  archiveText: "U kunt een leverancier archiveren, als u dit doet verschijnt de leverancier niet in zoekopdrachten van de applicatie. U kunt deze zien in de lijst met leveranciers als u filtert op 'gearchiveerd'. Zodra u de details van een gearchiveerde leverancier bekijkt, kunt u deze definitief verwijderen of de archivering ongedaan maken.",
  media: "Media",
  noMedia: "Er zijn geen gekoppelde media",
  archivedText: "Deze leverancier is gearchiveerd, indien gewenst kunt u de archivering ongedaan maken door op de 'Herstellen' knop te klikken.",
  archiveSupplierTitle: "Leverancier archiveren",
  archiveSupplierText: "Weet u zeker dat u de leverancier '{supplier}' wilt archiveren? Als u deze archiveert, verschijnt deze niet in zoekopdrachten.",
  deleteText: "Deze leverancier is gearchiveerd, als u deze permanent wilt verwijderen, klik dan op de 'Verwijderen' knop. Let op dat als u deze verwijdert, de leverancier ophoudt te bestaan en niet kan worden hersteld.",
  deleteSupplierTitle: "Leverancier verwijderen",
  deleteSupplierText: "Weet u zeker dat u de leverancier '{supplier}' wilt verwijderen? Als u deze verwijdert, kunt u deze niet meer herstellen.",
  restoreSupplierTitle: "Leverancier herstellen",
  restoreSupplierText: "Weet u zeker dat u de leverancier '{supplier}' wilt herstellen? Als u deze herstelt, is deze niet langer gearchiveerd en verschijnt deze in zoekopdrachten van de applicatie.",
  supplierStatus: "Status van leverancier",
  products: "Producten",
  noProducts: "Er zijn geen gekoppelde producten",
  showHiddenProducts: "Toon verborgen producten",
  hideHiddenProducts: "Verberg verborgen producten",
  noHiddenProducts: "Er zijn geen verborgen producten",
  editProductsBelongSupplierText: "Bewerk producten die bij de leverancier horen",
  contacts: "Contacten",
  noContacts: "Er zijn geen gekoppelde contacten",
  editContactsBelongSupplierText: "Bewerk contacten die bij de leverancier horen",
  addContacts: "Contacten toevoegen",
  removeContactTitle: "Contact van leverancier verwijderen",
  removeContactText: "Weet u zeker dat u '{contact}' als contact voor leverancier '{supplier}' wilt verwijderen?",
  supplierSearch: "Leveranciers zoeken",
  removeMediaTitle: "Media verwijderen",
  removeMediaText: "Weet u zeker dat u het bestand wilt verwijderen? Als u het verwijdert, kunt u het niet meer herstellen.",
  exportErrorToast: "U heeft geen toestemming om boekingen te exporteren. Neem contact op met uw beheerder.",
  rates: "Tarieven",
  rate: {
    description: "Voeg hier de manieren toe waarop dit product verkocht kan worden.",
    descriptionOnlyView: "De manieren waarop dit product verkocht kan worden",
    create: "Tarief aanmaken",
    update: "Tarief bijwerken",
    delete: "Tarief verwijderen",
    duplicate: "Tarief dupliceren",
    duplicateBlock: "Dupliceren",
    basicInformation: "Basisinformatie",
    typeNoOptions: "Geen types beschikbaar",
    categoryNoOptions: "Geen categorieën beschikbaar",
    product: "Product",
    type: "Type",
    category: "Categorie",
    initDate: "Begindatum",
    endDate: "Einddatum",
    price: "Prijs",
    removeTitle: "Tarief verwijderen",
    singleRate: "U dupliceert het volgende tarief",
    blockRate: "U dupliceert het volgende blok",
    removeText: "Weet u zeker dat u het tarief van product '{product}' wilt verwijderen? Als u het verwijdert, kunt u het niet meer herstellen."
  },
  resource: {
    createNew: "Nieuw product aanmaken",
    basicInformation: "Basisinformatie",
    title: "Productdetails",
    archiveTitle: "Product van leverancier archiveren",
    archiveText: "Weet u zeker dat u het product '{resource}' van '{supplier}' wilt archiveren? Als u het archiveert, verschijnt het niet in zoekopdrachten.",
    media: "Media",
    noMedia: "Er zijn geen gekoppelde media",
    removeMediaTitle: "Media verwijderen",
    removeMediaText: "Weet u zeker dat u het bestand wilt verwijderen? Als u het verwijdert, kunt u het niet meer herstellen."
  }
};
